import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';

import PageHttp from '~/commons/components/PageHttp.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import meta from '../../config/meta';
import { env } from '../../config';
import Rankings from '../blocks/Rankings.jsx';
import Tabs from '../layout/Tabs.jsx';
import Header from '../layout/Header.jsx';

const unitTypes = ['student', 'schoolClass'];
const withins = [
  { key: 'schoolClass', label: '班級' },
  { key: 'school', label: '學校' },
  { key: 'all', label: '全港' },
];

const PageRankings = () => {
  const [resU, reqU, user] = useHttpStatus();
  const [filter, setFilter] = useState({
    unitType: null,
    within: null,
  });
  let { unitType, within } = filter;

  meta.set({ title: '排名龍虎榜' });

  if (user) {
    const { school: { settings } } = user;

    // default values
    unitType = unitType || unitTypes.find((k) => (
      Object
        .values(settings[`${k}Ranking`])
        .find((s) => s)
    ));
    within = within || withins.find(({ key }) => (
      settings[`${unitType}Ranking`][key]
    )).key;
  }

  const rankingOpened = useMemo(()=>{
    let fRankingOpened = true;
    if ( env.rankingSetting && env.rankingSetting.closeImage ) {
      let openDate = env.rankingSetting.openDate ? moment(env.rankingSetting.openDate) : moment().startOf('day');
      let closeDate = env.rankingSetting.closeDate ? moment(env.rankingSetting.closeDate) : moment().endOf('day');
      if ( openDate.isSameOrBefore(closeDate) ) {
        fRankingOpened = moment().isSameOrAfter(openDate) && moment().isSameOrBefore(closeDate);
      } else {
        fRankingOpened = moment().isSameOrAfter(openDate) || moment().isSameOrBefore(closeDate);
      }
    }
    return fRankingOpened;
  },[]);

  useEffect(() => {
    reqU({ url: '/api/core/users/self' });
  }, []);

  return (
    <div className="pb-4">
      <Header
        bg={{
          left: '/assets/img/header-1-left.png',
          right: '/assets/img/header-1-right.png',
          color: '#dcf6fc',
        }}
      >
        <h3 className="text-center my-4">
          排名龍虎榜
        </h3>
      </Header>
      {rankingOpened ? (
      <PageHttp res={resU}>
        {({ school: { settings } }) => (
          <div>
            <Tabs
              tabs={[
                { key: 'student', label: '個人榜' },
              ].filter(({ key }) => (
                Object
                  .values(settings[`${key}Ranking`])
                  .find((s) => s)
              ))}
              active={unitType}
              onChange={(t) => {
                let w = within;
                const s = settings[`${t}Ranking`];

                if (!s[w]) {
                  [w] = Object.keys(s).slice(-1);
                }

                setFilter({ unitType: t, within: w });
              }}
            />
            <div className="py-3 text-center">
              {
                withins
                  .filter(({ key }) => (
                    settings[`${unitType}Ranking`][key]
                  ))
                  .map(({ key, label }) => (
                    <button
                      key={key}
                      onClick={() => setFilter({ ...filter, within: key })}
                      className={`
                        btn mx-2 py-0 px-3 rounded-pill
                        ${within === key ? 'btn-primary' : ''}
                      `}
                    >
                      {label}
                    </button>
                  ))
              }
            </div>
            <Rankings
              user={user}
              filter={{
                ...filter,
                unitType,
                within,
              }}
            />
            <div className="py-3 text-center">
              *相同排名者會依姓名排先後次序
            </div>
          </div>
        )}
      </PageHttp>
      ) : (
        <div className="container text-center">
          <img src={env.rankingSetting.closeImage} className="w-100"/>
        </div>
      )}
    </div>
  );
};

export default PageRankings;
